import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

import SidebarItem from './SidebarItem.vue'
  import Logo from './Logo.vue'
  import {useRoute} from 'vue-router'
  import { useStore,mapGetters } from 'vuex' // useStore ===vue2.0中的this.$store
  import { ref,computed } from 'vue'

  // 在setup中获取store
  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const store = useStore()
  const route = useRoute()

  // 获取路由
  const permission_routes = computed(()=>{

    let menuLocal = store.state.permission.routes
    let menuServer = localStorage.getItem("menuList")
    let menuServerJson = JSON.parse(menuServer)
    let menu = []
    for(let i =0;i<menuLocal.length;i++){
      //登录页和首页默认存在
      if(menuLocal[i].name=='Login'||menuLocal[i].name=='layout'){
        menu.push(menuLocal[i])
      }
      if(menuServerJson == null || menuServerJson.length == 0){
          continue
      }
      for(let j = 0;j<menuServerJson.length;j++){
        if(menuServerJson[j].children.length === 0){
          if(menuServerJson[j].name == menuLocal[i].name){
            menu.push({
              name:menuLocal[i].name,
              path:menuLocal[i].path,
              meta:menuLocal[i].meta,
              component:menuLocal[i].component,
              children:menuLocal[i].children,
            })
          }
        }else{
          if(menuServerJson[j].name == menuLocal[i].name){
            let childMenu = []
            let localChildren = menuLocal[i].children
            let serverChildren = menuServerJson[j].children
            for(let x = 0;x<serverChildren.length;x++){
              for(let y = 0;y<localChildren.length;y++){
                if(serverChildren[x].name == localChildren[y].name){
                  childMenu.push({
                    name:localChildren[y].name,
                    path:localChildren[y].path,
                    meta:localChildren[y].meta,
                    component:localChildren[y].component,
                    children:[]
                  })
                }
              }
            }
            menu.push({
              name:menuLocal[i].name,
              path:menuLocal[i].path,
              meta:menuLocal[i].meta,
              component:menuLocal[i].component,
              children:childMenu,
            })
          }
        }
      }
    }
    return menuLocal
    // return store.state.permission.routes
  })

  const initMenu = function (data) {

  }


  const activeMenu = computed(()=>{
    const { meta, path } = route
    // if set path, the sidebar will highlight the path you set
    if (meta.activeMenu) {
      return meta.activeMenu
    }
    return path
  })
  // 是否折叠
  const isCollapse = computed(()=>{
    return !store.state.app.isCollapse
  })

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'has-logo':isCollapse.value})
  }, [
    _createVNode(Logo, { collapse: isCollapse.value }, null, 8, ["collapse"]),
    _createVNode(_component_el_scrollbar, { "wrap-class": "scrollbar-wrapper" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          "default-active": activeMenu.value,
          "active-text-color": "#fff",
          "background-color": "rgba(0,0,0,0)",
          "text-color": "#fff",
          "collapse-transition": false,
          class: "el-menu-vertical-demo",
          collapse: isCollapse.value,
          router: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission_routes.value, (route) => {
              return (_openBlock(), _createBlock(SidebarItem, {
                key: route.path,
                item: route,
                "base-path": route.path
              }, null, 8, ["item", "base-path"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active", "collapse"])
      ]),
      _: 1
    })
  ], 2))
}
}

})